/** Зачем: при паузе (меню) не удалять файл signaling-хостом — см. MysteryRoomMapGate.pauseToMainMenu + P2PBeta cleanup. */
export const MR_P2P_SOFT_UNMOUNT_KEY = 'mr_p2p_soft_unmount';
